module.exports = __webpack_public_path__ + "static/avantages_hospital-18f5d862ddc0f65e4f63554eba16b940.svg";